import { render } from "./ReplyPostMedia.vue?vue&type=template&id=6d899469&ts=true"
import script from "./ReplyPostMedia.vue?vue&type=script&lang=ts&setup=true"
export * from "./ReplyPostMedia.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/communityTalk/reply/ReplyPostMedia.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6d899469"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6d899469', __exports__)) {
    api.reload('6d899469', __exports__)
  }
  
  module.hot.accept("./ReplyPostMedia.vue?vue&type=template&id=6d899469&ts=true", () => {
    api.rerender('6d899469', render)
  })

}


export default __exports__